import { PeOrderListItem } from 'model/modules/pe/orders/peOrderList';
import mapPeCompanyShortFromApi from 'rtkQuery/sharespro/mapper/modules/pe/peCompany/mapPeCompanyShortFromApi';
import mapPaginationListFromApi from 'rtkQuery/sharespro/mapper/shared/mapPaginationListFromApi';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';

export const mapPeOrderListItemFromApi = (
  apiItem: ApiPeOrderListItem
): PeOrderListItem => {
  return {
    id: apiItem.id,
    company: mapPeCompanyShortFromApi(apiItem.company),
    operationType: apiItem.operation,
    status: apiItem.status,
    createdAt: new Date(apiItem.create_timestamp * 1000),
    quantity: apiItem.quantity,
    price: apiItem.price,
    volume: apiItem.sum,
    isAllowCancel: apiItem.is_allowed_cancel,
    subtitle1: apiItem.subtitle_1,
    subtitle2: apiItem.subtitle_2,
  };
};

const mapPeOrderListFromApi = (
  resp: SharesproApiResponse<ApiPaginationListResponse<ApiPeOrderListItem>>
): PaginationList<PeOrderListItem> => {
  return mapPaginationListFromApi<PeOrderListItem, ApiPeOrderListItem>(
    resp.data,
    mapPeOrderListItemFromApi
  );
};

export default mapPeOrderListFromApi;
